import { Box, IconButton, Paper, Typography } from '@mui/material';
import Row from 'components/base/row';
import CustomTooltip from 'components/customTooltip';
import { useIsMobile } from 'hooks/useIsMobile';
import IconInfo from 'icons/iconInfo';
import rootStore from 'mobx/rootStore';
import React from 'react';
import { thousandSeparator } from 'utils/constants';

export default function StatisticWidget({
  variant,
  name,
  value,
  infoText,
  isSmallDigit,
}: {
  variant: 'dark' | 'light';
  name: string;
  value: number;
  infoText?: string;
  isSmallDigit?: boolean;
}) {
  const isMobile = useIsMobile();
  const isIOS = rootStore.uiStore.isIOS;

  const bgcolor =
    variant === 'dark'
      ? 'customBackgrounds.elevation6'
      : 'customBackgrounds.contrast';
  const color =
    variant === 'dark' ? 'text.primary' : 'custom.globalContrastText';

  const mainVariant = isMobile ? (isSmallDigit ? 'f24' : 'f32') : 'f46';
  const secondVariant = isMobile ? 'f12' : 'f16';

  const px = isMobile ? 3 : 5;
  const py = isMobile ? 1.5 : 4;

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        px,
        py,
        height: isMobile ? 103 : 'auto',
        bgcolor,
        justifyContent: 'space-between',
      }}
    >
      <Row
        sx={{
          position: 'relative',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'start' : 'center',
        }}
      >
        <Typography color={color} variant={secondVariant}>
          {name}
        </Typography>
        {infoText && (
          <Box
            sx={{
              overflow: 'visible',
              position: 'absolute',
              right: 0,
              width: 16,
              height: 16,
            }}
          >
            <CustomTooltip
              title={
                <Typography variant="f14" sx={{ fontSize: '14px !important' }}>
                  {infoText}
                </Typography>
              }
            >
              <IconButton
                disableRipple={isMobile}
                sx={{
                  'position': 'absolute',
                  'top': '-50%',
                  'left': '-50%',
                  '&:hover': {
                    bgcolor: isMobile ? 'inherit' : '#FFFFFF66',
                  },
                  ...(isIOS && {
                    '&:active': { bgcolor: 'inherit' },
                    '&:focus': { bgcolor: 'inherit' },
                  }),
                }}
              >
                <IconInfo></IconInfo>
              </IconButton>
            </CustomTooltip>
          </Box>
        )}
      </Row>

      <Typography
        color={color}
        variant={mainVariant}
        sx={{
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          fontVariantNumeric: 'lining-nums tabular-nums',
        }}
      >
        {thousandSeparator(value)}
      </Typography>
    </Paper>
  );
}
